<div class="root">
  <div class="content-container" [class.justify-around]="justifyAroundCondition">
    <ng-container *ngFor="let item of steps; let i = index">
      <div class="item">
        <div class="circle" [class.secondary]="i <= currentStepIndex">
          {{ i + 1 }}
        </div>

        <span *ngIf="isDesktop" class="text" [class.secondary]="i <= currentStepIndex">{{ item.name }}</span>
      </div>
    </ng-container>
  </div>
</div>
